import { trackPhoneClick, trackWhatsAppClick } from '../../hooks/useAnalytics';

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col space-y-3 z-40">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/905537165561"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick('+905537165561', 'floating_button')}
        className="group relative w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
          WhatsApp
        </span>
      </a>

      {/* Phone Button */}
      <a
        href="tel:+905537165561"
        onClick={() => trackPhoneClick('+905537165561', 'floating_button')}
        className="group relative w-14 h-14 bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center animate-pulse"
        aria-label="Telefon ile ara"
      >
        <i className="ri-phone-line text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
          Hemen Ara
        </span>
      </a>
    </div>
  );
};

export default FloatingButtons;
